import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class AvantLinkMerchantData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            merchants: [],
            merchantsLoading: false,
            MerchantsTable: {
                title: "Affiliate merchants",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'merchantName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getMerchants();
    };

    getMerchants = async () => {
        let url = `/api/Merchant/GetAvantLinkMerchants`;

        this.setState({ merchantsLoading: true });

        try {
            const merchants = await getRequest(url);

            this.setState({
                merchants,
                merchantsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching merchants:", error);
            this.setState({ merchants: [], merchantsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "hostname",
                label: "Hostname",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "merchantId",
                label: "Merchant ID",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "merchantName",
                label: "Merchant Name",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <b>{value}</b>;
                    }
                }
            },
            {
                name: "merchantCategoryId",
                label: "Merchant Category ID",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "merchantCategoryName",
                label: "Merchant Category Name",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "associateStatus",
                label: "Associate Status",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value === "active" ? "🟢 active" : "🔴 inactive"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "commissionAction",
                label: "Commission Action",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "commissionType",
                label: "Commission Type",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "commissionRate",
                label: "Commission Rate",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ textAlign: "center", margin: 0 }}>
                                {value ? `${value}` : "-"}
                            </p>
                        );
                    }
                }
            },
            {
                name: "attributionModel",
                label: "Attribution Model",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "referralDays",
                label: "Referral Days",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return `${value} days`;
                    }
                }
            },
            {
                name: "reversalDays",
                label: "Reversal Days",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return `${value} days`;
                    }
                }
            },
            {
                name: "dateJoined",
                label: "Date Joined",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return DateTime.fromISO(value).toFormat('MM/dd/yyyy');
                    }
                }
            },
            {
                name: "merchantLogo",
                label: "Merchant Logo",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value) => {
                        return (
                            <img
                                src={value}
                                alt="Merchant Logo"
                                style={{ maxWidth: "100px", maxHeight: "40px" }}
                            />
                        );
                    }
                }
            },
            {
                name: "merchantUrl",
                label: "Merchant URL",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <a href={value} target="_blank" rel="noopener noreferrer">
                                {value}
                            </a>
                        );
                    }
                }
            },
            {
                name: "availableTools",
                label: "Available Tools",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <p style={{ minWidth: "300px" }}>
                                {value}
                            </p>
                        );
                    }
                }
            },
            {
                name: "defaultTrackingUrl",
                label: "Default Tracking URL",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <a href={value} style={{ width: "300px", wordWrap: "break-word", display: "inline-block" }} target="_blank" rel="noopener noreferrer">
                                {value}
                            </a>
                        );
                    }
                }
            },
            {
                name: "avantLinkExclusive",
                label: "AvantLink Exclusive",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value}</span>;
                    }
                }
            },
            {
                name: "networkConversionRate",
                label: "Network Conversion Rate",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return `${value}`;
                    }
                }
            },
            {
                name: "networkReversalRate",
                label: "Network Reversal Rate",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return `${value}`;
                    }
                }
            },
            {
                name: "networkAverageSaleAmount",
                label: "Network Average Sale Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return `${value}`;
                    }
                }
            },
            {
                name: "earningsPerClick",
                label: "Earnings Per Click",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return `${value}`;
                    }
                }
            },
            {
                name: "salesVolume",
                label: "Sales Volume",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return `${value}`;
                    }
                }
            },
            {
                name: "defaultProgramCommissionRate",
                label: "Default Program Commission Rate",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return `${value}`;
                    }
                }
            }
        ];


        return (
            <div>
                <ThemeProvider theme={this.state.MerchantsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Archivo', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " merchants" ?? "No affiliate selected"}</p>
                            </div>
                        }
                        data={this.state.merchants}
                        columns={columns}
                        options={{
                            ...this.state.MerchantsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.merchantsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default AvantLinkMerchantData;
